import { deletedAccountsSlice } from './deletedAccounts';
import { adminAccountContragentsDictionarySlice } from './providersDictionary';
import { adminAccountServicesDictionarySlice } from './servicesDictionary';
import { adminAccountStatistic } from './statistic';
import { combineReducers } from 'redux';

export const adminAccount = combineReducers({
    statistic: adminAccountStatistic,
    servicesDictionary: adminAccountServicesDictionarySlice.reducer,
    contragentsDictionary: adminAccountContragentsDictionarySlice.reducer,
    deletedAccounts: deletedAccountsSlice.reducer
});
